import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchBusinessFooter, fetchDashboardRankings } from '@/api/rankings';

export function useDashboardRankings(zoneId: string | number = 'all') {
  return useQuery({
    queryKey: ['dashboard', 'rankings', String(zoneId)],
    queryFn: () => fetchDashboardRankings(zoneId),
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
  });
}

export function useBusinessFooter() {
  return useQuery({
    queryKey: ['settings', 'business-footer'],
    queryFn: fetchBusinessFooter,
    staleTime: 10 * 60_000,
    select: (res) => ({
      businessName: res.data.business_name || '',
      footerText: res.data.footer_text || '',
      softwareVersion: res.data.software_version || '',
    }),
  });
}
